import { withQuery } from "./query";
import { Get, Post } from "./request";

export function CountCommunicationAudienceMembers(dispatch, request) {
  return Post(
    dispatch,
    "CountCommunicationAudienceMembers",
    "",
    request
  );
}

export function GetCommunicationAudienceMemberCount(dispatch, requestId) {
  return Get(dispatch, withQuery("GetCommunicationAudienceMemberCount", { requestId }));
}

export function GetCommunicationPublishStatus(dispatch, communicationId) {
  return Get(dispatch, withQuery("GetCommunicationPublishStatus", { communicationId }));
}

export function GetCommunicationAudienceExportStatus(dispatch, requestId) {
  return Get(dispatch, withQuery("GetCommunicationAudienceExportStatus", { requestId }));
}

export function ExportCommunicationAudienceToFile(
  dispatch,
  successMessage,
  communicationAudience
) {
  return Post(
    dispatch,
    "ExportCommunicationAudienceToFile",
    successMessage,
    communicationAudience
  );
}

export function ExportCommunicationAudienceToMarketingList(
  dispatch,
  successMessage,
  communicationAudience
) {
  return Post(
    dispatch,
    "ExportCommunicationAudienceToMarketingList",
    successMessage,
    communicationAudience
  );
}

export function ActivateEmailMarketing(dispatch, customerId, code) {
  return Get(
    dispatch,
    withQuery("ActivateEmailMarketing", {
      customerId,
      activationCode: code,
    })
  );
}

export function GetCommunicationAudienceRules(dispatch, runAt) {
  return Get(
    dispatch,
    withQuery("GetCommunicationAudienceRules", { runAt })
  );
}

export function GetCommunicationOptions(dispatch) {
  return Get(dispatch, `GetCommunicationOptions`);
}

export function GetCommunicationStatistics(
  dispatch,
  communicationId,
  useCloudStorage,
  returnEmailHtml
) {
  let url = withQuery("GetCommunicationStatistics", {
    communicationId,
    useCloudStorage,
    returnEmailHtml,
  });
  return Get(dispatch, url);
}

export function ResendCommunicationActivity(
  dispatch,
  id,
  communicationId
) {
  return Get(
    dispatch,
    withQuery("ResendCommunicationActivity", { id, communicationId })
  );
}

export function StartCommunication(dispatch, id) {
  return Get(dispatch, withQuery("StartCommunication", { id }));
}

export function StopCommunication(dispatch, id) {
  return Get(dispatch, withQuery("StopCommunication", { id }));
}

export function UnpublishTriggerFlow(dispatch, id) {
  return Get(dispatch, withQuery("UnpublishTriggerFlow", { id }));
}
